var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpandArrows(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ARROW_48",
    "data-name": "ARROW 48"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m487.84 272.85a24 24 0 0 0 -24 24v96.61a70.46 70.46 0 0 1 -70.38 70.38h-274.92a70.46 70.46 0 0 1 -70.38-70.38v-274.92a70.46 70.46 0 0 1 70.38-70.38h96.61a24 24 0 1 0 0-48h-96.61a118.52 118.52 0 0 0 -118.38 118.38v274.92a118.52 118.52 0 0 0 118.38 118.38h274.92a118.52 118.52 0 0 0 118.38-118.38v-96.61a24 24 0 0 0 -24-24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m487.33 0h-149.2a24 24 0 0 0 -24 23.53c-.25 13.47 11.08 24.47 24.54 24.47h91.33l-191.14 191.2a24 24 0 0 0 0 33.94 24 24 0 0 0 33.94 0l191.2-191.14v91.66a24 24 0 0 0 48 0v-149a24.66 24.66 0 0 0 -24.67-24.66z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandArrows);
export default __webpack_public_path__ + "static/media/expand-arrows.824622c2808efbdec12cfd6b52e420f9.svg";
export { ForwardRef as ReactComponent };